<template>
  <div class="card-normal">
    <div v-if="carregando" class="carregando"><i class="el-icon-loading"></i></div>
    <div :class="carregando ? 'blur' : ''">

      <el-select v-model="mes_selecionado" placeholder="Select" @change="selecionado()">
        <el-option v-for="item in meses" :key="item.id" :label="item.mes" :value="item.id" />
      </el-select>
      <el-input-number class="ml-2" v-model="ano_selecionado" :min="1" @change="selecionado()" />

      <h2>Histórico diário de {{hoje.format('MMMM')}}</h2>
      <div v-if="hor_array.length === 0" class="py-4">
        <span style="opacity: .5;">O colaborador ainda não bateu ponto neste mês.</span>
      </div>
      <div v-else class="dia" v-for="(item, index) in hor_array" :key="index">
        <p class="data">{{item.dia}} <span v-if="item.minutos !== '-'" style="text-transform: lowercase !important">-
            {{`${parseInt(item.minutos / 60)}h ${('0' + (item.minutos % 60)).slice(-2)}m`}}</span></p>
        <el-row :gutter="30">
          <el-col v-for="(hora, index) in filtroArrayHora(item.info, isNotEqual)" :key="index"
            :span="12" :style="(hora.tipo === 'entrando') ? 'text-align: right' : 'text-align: left'">
            <span class="hora">{{hora.horario}}</span>
            <i class="fas" :class="(hora.tipo === 'entrando') ? 'fa-arrow-up verde' : 'fa-arrow-down vermelho'"></i>
          </el-col>
          <el-col v-for="(hora, index) in filtroArrayHora(item.info, isEqual)" :key="index" :span="24">
            <el-tooltip effect="light" :content="hora.justificativa" placement="top">
              <p class="justificativa">Horário justificado: {{`${parseInt(hora.minutos / 60)}h
                ${('0' + (hora.minutos % 60)).slice(-2)}m`}}</p>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { isEqual } from 'lodash';
import meses from './meses';

export default {
  name: 'HistoricoDiario',
  data: () => ({
    carregando: false,
    hor_array: [],
    hoje: moment(),
    meses,
    mes_selecionado: null,
    ano_selecionado: null
  }),
  created() {
    this.mes_selecionado = Number(this.hoje.format('M')) - 1;
    this.ano_selecionado = this.hoje.format('YYYY');
    this.getHorarios();
  },
  methods: {
    isEqual,
    isNotEqual(a, b) {
      return !isEqual(a, b);
    },
    selecionado() {
      this.hoje.month(this.mes_selecionado);
      this.hoje.year(this.ano_selecionado);
      this.getHorarios();
    },
    getHorarios() {
      this.hor_array = [];
      this.carregando = true;
      const ref = `horarios/${this.$route.params.user}/${this.hoje.format('YYYY')}/${this.hoje.format('MM')}`;
      const refHorario = this.$db.ref(ref);
      refHorario.on('value', snap => {
        this.hor_array = [];

        if (snap.exists()) {
          const dias = Object.entries(snap.val());
          dias.forEach(dia => {
            const dia_key = `${dia[0]} de ${this.hoje.format('MMMM')} de ${this.hoje.format('YYYY')}`;
            const horarios = Object.values(dia[1]);
            const info = [];
            horarios.forEach(hor => {
              info.push({
                horario: moment(hor.data).format('HH:mm'),
                tipo: hor.tipo,
                minutos: (hor.tipo === 'justificativa') ? hor.minutos : null,
                justificativa: (hor.tipo === 'justificativa') ? hor.justificativa : null
              });
            });
            this.hor_array.push({
              dia: dia_key,
              info: info,
              minutos: this.minutosTrabalhados(info)
            });
          });

          this.hor_array.sort((a, b) => {
            if (a.dia > b.dia) return -1;
            if (a.dia < b.dia) return 1;
            return 0;
          });
        }
        this.carregando = false;
      });
    },
    minutosTrabalhados(dia) {
      if (dia && dia.length === 0) return 0;
      let soma = 0;
      for (let i = 0; i < dia.length; i += 1) if (dia[i].tipo === 'saindo') {
        const df = moment(dia[i].horario, 'HH-mm');
        const di = moment(dia[i - 1].horario, 'HH-mm');
        soma += df.diff(di, 'minutes'); // Diferença em minutos entre dois horários
      } else if (dia[i].tipo === 'justificativa') soma += dia[i].minutos;

      return soma;
    },
    filtroArrayHora(arr, op) {
      return arr.filter(a => op(a.tipo, 'justificativa'));
    }
  }
};
</script>

<style lang="scss" scoped>
.carregando {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-items: center;
  text-align: center;

  i {
    margin: 0 auto;
    font-size: 30px;
  }
}
</style>
